import { render, staticRenderFns } from "./ScrollToTopBtn.vue?vue&type=template&id=0611589c&scoped=true&"
import script from "./ScrollToTopBtn.vue?vue&type=script&lang=js&"
export * from "./ScrollToTopBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0611589c",
  null
  
)

export default component.exports